var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        ref: "grid",
        attrs: {
          title: "",
          tableId: "grid",
          topBorderClass: "topcolor-orange",
          columns: _vm.grid.columns,
          data: _vm.grid.data,
          isFullScreen: false,
          columnSetting: false,
          filtering: false,
          usePaging: false,
          hideBottom: true,
          isExcelDown: true,
          isTop: true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }